export default [
  {
    id: '1',
    parentId: '0',
    title: '工作台',
    path: '/services/work',
    type: 2,
    component: '/services/work/work',
    isHidden: false,
    icon: 'kl-work'
  }
]
